export type ConfirmCallback = (allowNavigation: boolean) => void;

export type ConfirmFn = (message: string, callback: ConfirmCallback) => void;

let warned = false;

export const noopConfirm: ConfirmFn = (_message, callback) => {
  if (!warned) {
    warned = true;
    console.warn(
      "UnsavedChangesHost not mounted; navigation guards will not show modal. " +
        "Mount <UnsavedChangesHost /> as a child of <BrowserRouter />.",
    );
  }
  callback(true);
};

// Test-only helper to reset the one-shot warn flag between test runs.
export function resetNoopWarnedForTesting() {
  warned = false;
}
